import React from 'react';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import PCNewReleaseGames from '@/pages/intelligence/pages/Potential/NewReleaseGames/PCGame';

export default function NewRelease() {
  const pageLogInfo = dbiPageLogMes.topChartsPCGamesNewRelease;
  const entityType = 'pc';
  return (
    <>
      <MarqueeBanner />
      <PCNewReleaseGames entityType={entityType} pageLogInfo={pageLogInfo} />
    </>
  );
}


